var render = function render(){var _vm=this,_c=_vm._self._c;return _c('youtube',{attrs:{"video-id":_vm.videoId,"player-vars":_vm.playerVars}})
}
var staticRenderFns = []

export { render, staticRenderFns }